export default __webpack_public_path__ + "static/media/Sepulcher.53d262e2.jpg";